import { format, parseISO } from 'date-fns'
import { Avatar } from '../../catalyst/avatar'
import { ErrorMessage, Field } from '../../catalyst/fieldset'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../catalyst/table'
import { getSyncRunStatusBadge } from '../../utils'

export function SyncRunsTable({ syncRuns }) {





  return (
    syncRuns.length == 0 ? (
      <Field>
        <ErrorMessage>No runs occured for this sync</ErrorMessage>
      </Field>
    ) : (
      <>
      
    <Table className="[--gutter:--spacing(6)] sm:[--gutter:--spacing(8)]">
      <TableHead>
        <TableRow>
          <TableHeader>Run date</TableHeader>
          <TableHeader>Status</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {syncRuns.map((syncRun) => (
          <TableRow key={syncRun.id}>
            <TableCell>
              <div className="flex items-center gap-4">
                <Avatar src={"https://picsum.photos/300/200?grayscale&id=" +syncRun.id } className="size-12" />
                <div>
                  <div className="font-medium">Run at {format(parseISO(syncRun.startedOn), "eeee, MMMM do, yyyy 'at' h:mm a")}</div>
                  <div className="text-zinc-500">
                    <span className="hover:text-zinc-700">
                      {syncRun.songsAdded}/{syncRun.songsToAdd} tracks added
                    </span>
                  </div>
                  <div className="text-zinc-500">
                    <span className="hover:text-zinc-700">
                      {syncRun.songsRemoved}/{syncRun.songsToRemove} tracks removed
                    </span>
                  </div>
                </div>
              </div>
            </TableCell>
            <TableCell>{getSyncRunStatusBadge(syncRun)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </>
    )
  )

  
}